import { useState } from 'react';

const badgeStyle = {
    fontSize: 11, fontWeight: 500,
    background: '#f0fdf4', color: '#16a34a',
    border: '1px solid #bbf7d0',
    borderRadius: 20, padding: '2px 8px',
};

const VISIBLE_COUNT = 4;

export default function RightsCell({ rights }) {
    const [expanded, setExpanded] = useState(false);

    if (!rights || rights.length === 0) {
        return <span className="cell-muted">Aucun droit assigné</span>;
    }

    const hasMore = rights.length > VISIBLE_COUNT;
    const visibleRights = expanded ? rights : rights.slice(0, VISIBLE_COUNT);

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {visibleRights.map(r => (
                <span key={r} style={badgeStyle}>{r}</span>
            ))}
            {hasMore && (
                <span
                    role="button"
                    onClick={() => setExpanded(prev => !prev)}
                    style={{
                        ...badgeStyle,
                        background: '#f3f4f6', color: '#374151',
                        border: '1px solid #e5e7eb',
                        cursor: 'pointer',
                    }}
                >
                    {expanded ? 'Voir moins' : `+${rights.length - VISIBLE_COUNT}`}
                </span>
            )}
        </div>
    );
}
